import React from 'react';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import SVGIcon from 'lib/images/svg-icon/svg-icon';
import FormattedDateAgoView from 'lib/intl/formatted-date-ago-view';
import clock from 'four-nets/icons/svg/icon_time.svg';

import { displayedName } from 'four-nets/user/utils';
import Avatar from 'four-nets/avatar/avatar';
import { PostType } from 'four-nets/photoblog/posts/post.graphql.types';
import { PostFragment } from 'four-nets/photoblog/posts/post.graphql';
import VendorBadge from 'four-nets/ui-v2/badges/vendor-badge/vendor-badge';

import defaultStyles from './header.scss';

export interface Props extends PostFragment {
    styles: typeof defaultStyles;
}

class Header extends React.PureComponent<Props> {
    render() {
        const { styles, lastChangeTime, postType, newImagesCount, user, href } = this.props;
        const isVendor = user && user.profile && user.profile.isVendor;
        const { profile, username } = user!;

        return profile ? (
            <div className={styles.header}>
                <div className={styles.avatarWrapper}>
                    <Avatar user={user} />
                </div>
                <div className={styles.user}>
                    <div className={styles.username}>
                        <Link
                            className={styles.link}
                            to={profile.isVendor ? `/catalog/vendor/${username}` : `/blog/${username}/`}
                        >
                            {profile.isVendor && profile.vendor && profile.vendor.name
                                ? profile.vendor.name
                                : displayedName(user!)}
                        </Link>
                        {isVendor ? <VendorBadge /> : null}
                        {newImagesCount && postType === 'POST_ALBUM' ? (
                            <React.Fragment>
                                <FormattedMessage
                                    id='HAS_ADDED_%(counter)s_NEW_PHOTOS'
                                    values={{
                                        gender: profile && profile.sex === 1 ? 'f' : 'm',
                                        counter: newImagesCount,
                                    }}
                                >
                                    {msg => (
                                        <span className={styles.newImagesCount}>
                                            &nbsp;
                                            {(msg as string).split(' ').map((word, i) => {
                                                if (i === 0) {
                                                    return (
                                                        <span key={word} className={styles.firstWord}>
                                                            {word}
                                                        </span>
                                                    );
                                                }
                                                return ` ${word}`;
                                            })}
                                        </span>
                                    )}
                                </FormattedMessage>
                            </React.Fragment>
                        ) : null}
                    </div>
                    <Link to={href} className={styles.lastChangeTime}>
                        <SVGIcon style={{ image: styles.icon }} src={clock} />
                        <FormattedDateAgoView value={new Date(lastChangeTime!)} />
                    </Link>
                </div>
            </div>
        ) : null;
    }
}

export default Styled(defaultStyles)(Header);
